import { render, staticRenderFns } from "./DeliveryKuaidi.vue?vue&type=template&id=a69f80ae&scoped=true&"
import script from "./DeliveryKuaidi.vue?vue&type=script&lang=js&"
export * from "./DeliveryKuaidi.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryKuaidi.vue?vue&type=style&index=0&id=a69f80ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a69f80ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a69f80ae')) {
      api.createRecord('a69f80ae', component.options)
    } else {
      api.reload('a69f80ae', component.options)
    }
    module.hot.accept("./DeliveryKuaidi.vue?vue&type=template&id=a69f80ae&scoped=true&", function () {
      api.rerender('a69f80ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/delivery/components/DeliveryKuaidi.vue"
export default component.exports